import React from 'react';
import { Alert, CloseButton, Flex, Text } from '@chakra-ui/react';
import { CONFIG } from '../constants/message';
import { useMessageContext } from '../context/messageContext';

const Message = () => {
  const { messages, setMessages } = useMessageContext();
  const deleteMessage = (index) => {
    setMessages((prevMessages) => prevMessages.filter((_, i) => i !== index));
  };
  if (messages.length === 0) return null;
  return (
    <Flex gap="0.75rem">
      {messages.map(({ message, type }, index) => (
        <Alert
          borderRadius="4px"
          key={message}
          status={type}
          bg={CONFIG[type].bg}
          alignItems="center"
          justifyContent="space-between"
          p="15px"
          mb="20px"
        >
          <Text
            variant={CONFIG[type].variant}
            textAlign="center"
            fontSize="14px"
            flexGrow={1}
          >
            {message}
          </Text>
          <CloseButton
            opacity={0.2}
            color="#000"
            onClick={() => deleteMessage(index)}
          />
        </Alert>
      ))}
    </Flex>
  );
};

export default Message;
